import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfo = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM9.225 5.375C9.225 6.05155 8.67655 6.6 8 6.6C7.32345 6.6 6.775 6.05155 6.775 5.375C6.775 4.69845 7.32345 4.15 8 4.15C8.67655 4.15 9.225 4.69845 9.225 5.375ZM9 12V7.5H7V12H9Z",
		fill: "currentColor"
	})]
});
export default SvgInfo;
